<template>
  <div class="home">
    <div class="wrapper">
      <!-- 地图区域 -->
      <div id="mapBox">
      </div>
      <!-- 滚动区域 -->
      <div class="srcollWrap">
        <!-- 站牌信息 附近展开-->
        <div class="BusStation">
          <div class="stationName" @click="stationLineInfo(stationListFirst)">
            <div class="stationTitle">
              <img :src='imgUrl' width="22px" height="22px" class="imgIcon">
              <span class="title">{{stationListFirst.stationName}}</span>
            </div>
          </div>
          <!-- 附件站点展开 -->
          <!-- xxx -->
          <div class="lineInfo" v-for="(line,index) in lineItemList" :key="index" @click="lineClick(line)">
              <!-- 还剩0站 -->
              <div v-if="line.stationSep == 0">
                <div class="lineTop commonBox">
                      <div class="lineName">{{line.lineName}}</div>
                  </div>
                  <div class="lineBottom commonBox">
                    <div class="lineDirection">
                      开往<span class="destination">{{line.lastStationName}}</span>
                    </div>
                    <div class="titleStyle">
                      即将到站
                    </div>
                </div>
                
              </div>
              <!-- 大于0站 -->
              <div v-else>
                  <div class="lineTop commonBox">
                      <div class="lineName">{{line.lineName}}</div>
                      <div class="lineTime">
                        <span class="timeNumber">{{line.runTime}}</span><span class="unitStyle">{{line.timeUnit}}</span>
                      </div>
                  </div>
                  <div class="lineBottom commonBox">
                    <div class="lineDirection">
                      开往<span class="destination">{{line.lastStationName}}</span>
                    </div>
                    <div class="lineFar">
                      {{line.stationSep}}站/{{line.distance}}{{line.distanceUnit}}
                    </div>
                </div>
              </div> 
          
          </div>
          <!-- xxxsd -->
          <div class="watchMore" v-if="flagLength" @click="stationLineInfo(stationListFirst)">
            查看更多
          </div>
        </div>
        <!-- 不展开的站牌信息 -->
        <div class="stationWrap">
          <!-- 循环 -->
          <div class="stationBigName" v-for="(item,index) in stationListNoFirst" :key="index" @click="stationLineInfo(item)">
            <div class="stationBigTitle">
              <img :src='imgUrl' width="22px" height="22px" class="imgIcon">
              <span class="BigTitle">{{item.stationName}}</span>
            </div>
            <div class="commonBox">
                <!-- <div class="farMiles">
                236米
                </div> -->
              <div class="right-arrow">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from 'AMap'
import {setLocalStorage, getLocalStorage} from '@/utils/session.js'
export default {
  name: "mapPage",
  components: {},
  data(){
    return{
      active:0, 
      imgUrl:require('../../assets/image/station.png'),
      stationList:[],
      stationListFirst:{},
      stationListNoFirst:[],
      flagLength:true,
      lineItemList:[],
      timeList:[],
      timer:null,//定时器
      mapBox:null,
      latLng:{},

    }
  },
   mounted(){
     this.latLng = getLocalStorage('LatLng')
     this.initMap(this.latLng.lng,this.latLng.lat)
     this.mapStation(this.latLng.lat,this.latLng.lng)
     this.$wxHide()
   },
   beforeRouteLeave(to, from, next){
    console.log('离开地图页，清除定时器')
    next()
    clearInterval(this.timer)
     this.timer = null
   },
  methods:{
      initMap (lng,lat) {
        this.mapBox = new AMap.Map('mapBox', {
            resizeEnable: true, //是否监控地图容器尺寸变化
            zoom:15, //初始化地图层级
            center: [lng, lat],//初始化地图中心点
            viewMode: '2D',  //设置地图模式
            lang:'zh_cn',  //设置地图语言类型
         });
         this.nearStation(lng, lat)
       },
      nearStation(lng,lat){
        let params ={
          latitude:lat,
          longitude:lng
        }
        this.$api['station.mapStation'](params).then(res => {
            if(res && res.length){
               let iconSelf = new AMap.Icon({
                  size: new AMap.Size(20, 20),
                  image: require('../../assets/image/station.png'),
                  imageSize: new AMap.Size(18, 19) 
               });
              for (var i = 0, marker; i < res.length; i++) {
                  var marker = new AMap.Marker({
                    position: [res[i].longitude ,res[i].latitude],//不同标记点的经纬度
                    map: this.mapBox,
                    icon: iconSelf
                  });
                  marker.setLabel({
                    // offset: new AMap.Pixel(0,-3),  //设置文本标注偏移量
                    content:`<div class='info'>${res[i].stationName}</div>`, //设置文本标注内容
                    direction: 'top' //设置文本标注方位
                   });
                  marker.setMap(this.mapBox)
                  
                }
                var markerFrist =  new AMap.Marker({
                    position: [lng ,lat],//不同标记点的经纬度
                    map: this.mapBox,
                    icon: iconSelf
                  });
                this.mapBox.setFitView(markerFrist);
               
            }
        })
     },
    mapStation(lat,lng){
      let paramasLocation ={
        latitude:lat,
        longitude:lng
      }
      //3.2 地图附近站点查询
      this.$api['station.mapStation'](paramasLocation).then(res => {
        if(res && res.length){
          this.stationListFirst=res[0]
          this.stationListNoFirst= res.slice(1)
          this.getLineStation(this.stationListFirst);
          //查询第一个站点下的线路数据
          //一分钟更新一次数据
            this. timer = setInterval(()=>{
             this.getLineStation(this.stationListFirst);
            },1000*60)
          }
        })
    },
    // 3.3 查询站牌下的线路
    getLineStation(station){
      this.$api['station.findLineByStation'](station).then(res=>{
        if(res && res.length) {
          this.flagLength = false
          if (res.length > 3) {
            res = res.slice(0,3)
            this.flagLength = true
          }
          let arr = []
          res.forEach(item => {
            arr.push(this.getTwoBusInfo(item))
          })
          Promise.all(arr).then((posts) =>  {
            this.lineItemList = res.map((item, index) => {
              return Object.assign({}, item, posts[index])
            })
          })
        }
      })
    },
    // 3.4 获取多条线路的最近两辆车辆到站情况
    async  getTwoBusInfo(item){
       let obj = {}
       const stationlineList = [{businessType:item.businessType ,dirctionType:item.dirctionType,lineCode: item.lineCode, lineType: item.lineType, lineStationId: item.lineStationId }]
       let arr = await this.$api['station.timetable'](stationlineList)
       if (arr && arr.length) {
          let lineBus = arr[0].busPosition[0]
          obj = this.handleList(item,lineBus)
          return obj
        }
    },
    //处理线路上的时间和距离
    handleList(line, item){
      const newObj = {
        runTime:  (item.runTime * 1) >= 60 ?  (item.runTime * 1 / 60).toFixed(0)  : item.runTime ,
        timeUnit: (item.runTime * 1) >= 60 ?  "分钟" :'秒',
        distance: (item.distance * 1)>= 1000 ? ((item.distance * 1)/1000).toFixed(1) + '公里': item.distance + '米',
        stationSep: !item.seq ? 0 : (line.seq * 1)- (item.seq * 1)
      }
      return Object.assign({}, newObj)
    },
    //点击站牌跳转
    stationLineInfo(item){
      this.$router.push({name:"stationDetails",params:{station:item}})
      this.$session.setSession('station',item)
    },
    //点击线路跳转
    lineClick(item){
        this.$router.push({name:"lineDetails",params:{line:item,flag:2}})
        this.$session.setSession('line',item)
     }
  }
}
</script>
<style scoped lang="scss">
.home{
  font-size:0.12rem;
  width:100%;
  height:100%;
  overflow:hidden;
  .wrapper{
    background-color: #F8F8F8;
    height:100%;
    overflow:hidden;
    #mapBox{
     width:100%;
     height:30vh;
    }
    .srcollWrap{
      height: calc(100vh - 1.3rem);
      overflow: auto;
      // padding: 0 0.15rem;
      padding-bottom: 0.2rem;
      margin-bottom: 0.1rem;
      .BusStation{
        background-color: #fff;
        border-radius: 5px;
        padding:0rem 0.15rem;
        align-items: center;
        box-shadow: 2px 2px 13px 1px #DDE2F7;
        .stationName{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width:100%;
            border-bottom: 1px solid #EEE;
            padding:0.12rem 0rem;
            .stationTitle{
                display: flex;
                align-items: center;
                flex: 1 auto;
                .imgIcon{
                    padding-right: 0.1rem;
                }
                .title{
                    font-size:14px;
                    font-weight:600;
                    color:#333;
                }
             }
            .distance{
                display: flex;
                align-items: center;
                font-size:0.12rem;
                color:#333;
             }
      }
      .lineInfo{
        border-bottom: 1px solid #EEE;
        .lineTop{
          padding:0.1rem 0rem;
          .lineName{
            font-size:0.18rem;
            font-weight:600;
            color:#333;
          }
          .lineTime{
            font-size:0.12rem;
            color: #FF8056;
            .timeNumber{
                font-size:0.26rem;
              //  font-weight: 600
            }
            .unitStyle{
                font-size:0.16rem;
            }
          }
        }
        .lineBottom{
          padding-bottom:0.1rem;
          .lineDirection{
            color:#666666;
            font-size: 14px;
            .destination{
              padding-left:0.1rem
            }
          }
          .lineFar{
            color:#546AD9;
            font-size: 14px;
          }
         
        }
      };
      .watchMore{
        text-align: center;
        font-size:0.13rem;
        color:#666;
        padding:0.1rem 0rem;
      }
    }
    .stationWrap{
      .stationBigName{
        background-color:#fff ;
        border-radius:6px;
        margin-top:0.1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
      //  width:100%;
        border-bottom: 1px solid #EEE;
        padding:0.12rem 0.1rem;
        box-shadow: 2px 2px 13px 1px #DDE2F7;
        .stationBigTitle{
          display: flex;
          align-items: center;
          flex: 1 auto;
          .imgIcon{
            padding-right: 0.1rem;
          }
          .BigTitle{
            font-size:14px;
            font-weight:600;
            color:#333;
          }
        }
      
        .farMiles{
            display: flex;
            align-items: center;
            font-size:0.12rem;
            color:#333;
          }
          .right-arrow {  
              width: 6px;
              height:6px;
              border-top: 1px solid #333;
              border-right: 1px solid #333;
              transform: rotate(45deg);
              margin-left:0.08rem;
          }
        
      }
    }
    }
  };
  .tabBox{
      width:100%;
      height: 0.4rem;
  }
}
.commonBox{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.marginBox{
  margin-top:0.1rem
}
.titleStyle{

  font-size:0.15rem;
  color:#FF8056
}
</style>>